import ReactDOM from 'react-dom';
import { useOutside } from "hooks/UseOutside";
import {
  Dispatch, SetStateAction, useRef, useState
} from "react";
import { Container, ModalContainer, ProductPhoto } from './_productPhotoModal';
import { ModalCloseButton } from '../SendDocumentsModal/_sendDocumentsModal';

interface IProductPhotoModalProps {
  url: string;
  toggleModal: Dispatch<SetStateAction<boolean>>;
}

export const ProductPhotoModal = ({ url, toggleModal }: IProductPhotoModalProps) => {
  const modalRoot = document.getElementById('root-modal');
  const modalRef = useRef(null);

  const [hideModal, setHideModal] = useState(false);

  const handleCloseModal = () => {
    setHideModal(true);

    setTimeout(() => {
      toggleModal(false);
    }, 500);
  }


  useOutside(modalRef, handleCloseModal);

  if(!modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(
    <Container className={`${hideModal ? 'modal-agenda-details--hide' : ''}`}>
      <ModalContainer ref={modalRef}>
        <ModalCloseButton
          type="button"
          onClick={handleCloseModal}
        >
          X
        </ModalCloseButton>
        <ProductPhoto src={url} alt="" onError={(e: any) => {
          e.target.style = "visibility: hidden;"
        }} />
      </ModalContainer>
    </Container>,
    modalRoot
  )
}
